export default __webpack_public_path__ + "static/retirement-helpers-5514a5aa382e2e31f2eb68e628ba55ee.svg";